export const helpers = {
  methods: {
    floatString(num, minDecimals = 2, maxDecimals = 2) {
      return parseFloat(num).toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
    isLandscape() {
      return screen.orientation.type.toString().includes("landscape") > -1;
    },
    isPortrait() {
      return screen.orientation.type.toString().includes("portrait") > -1;
    },

    formatNumberForDisplay(num, format = "both") {
      //VALID FORMATS ARE 'html','text','both
      let strNum = this.floatString(Math.abs(num)); //TAKING ABSOLUTE VALUE REGARDLESS

      // console.log("STRNUM (BEFORE APPLICATION):", strNum);
      if (["text", "both"].indexOf(format) > -1) {
        strNum = num < 0 ? `\(${strNum}\)` : strNum;
        // console.log("STRNUM (AFTER TEXT):", strNum);
      }

      if (["html", "both"].indexOf(format) > -1) {
        let klass = num < 0 ? "negative" : "positive";
        strNum = `<span class="${klass}">${strNum}</span>`;
        // console.log("STRNUM (AFTER HTML):", strNum);
      }
      return strNum;
    },
  },
};
